module.exports = __webpack_public_path__ + "@/assets/img/backlogin.0a31902b.jpeg";